import { useInfiniteQuery } from 'react-query';
import {
  getSceneOriginalEpisodes,
  type SceneOriginalEpisodesParams,
  type SceneOriginalEpisodesPageResponse
} from '../../services/sceneService';

export function useGetSceneOriginalEpisodes(sceneId: string, params?: SceneOriginalEpisodesParams) {
  const baseParams = params ?? {};

  return useInfiniteQuery(
    ['sceneOriginalEpisodes', sceneId, baseParams],
    ({ pageParam }): Promise<SceneOriginalEpisodesPageResponse> =>
      getSceneOriginalEpisodes({
        sceneId,
        params: {
          ...baseParams,
          cursor: pageParam ?? baseParams.cursor
        } as SceneOriginalEpisodesParams
      }),
    {
      enabled: !!sceneId,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      getNextPageParam: (lastPage) => {
        const { hasMore, nextCursor } = lastPage.meta.pagination;
        if (!hasMore || !nextCursor) return undefined;
        return nextCursor;
      }
    }
  );
}
